"use client";

import { isConversationalEndpoint } from "@/lib/utils/common";
import { CONVERSATIONAL_ENDPOINTS } from "@/constants/constants";
import { usePathname } from "next/navigation";

export default function DynamicBody({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const pathname = usePathname();
  const segments = pathname.split("/").filter(Boolean);

  const isConversational =
    segments.some((seg) => isConversationalEndpoint(seg)) ||
    CONVERSATIONAL_ENDPOINTS.some((ep) => pathname === `/${ep}` || pathname.includes(`/${ep}/`));

  const bg = isConversational ? "bg-conversational-gradient" : "";

  return <div className={`min-h-screen w-full flex flex-col ${bg}`}>{children}</div>;
}
